<template>
  <form @submit.prevent="validateForm">
    <div class="relative flex py-5 items-center">
      <div class="flex-grow border-t border-gray-400"></div>
      <span class="flex-shrink mx-4 text-3xl font-bold">Data Pribadi</span>
      <div class="flex-grow border-t border-gray-400"></div>
    </div>
    <div class="space-y-11">
      <div
        class="border-b border-gray-900/10 pb-12 px-6 pt-2 mt-4 shadow-md rounded-xl bg-white"
      >
        <h2 class="text-base font-semibold leading-7 text-gray-900 mt-6">
          Kontak
        </h2>
        <p class="mt-1 text-sm leading-6 text-gray-600">
          Informasi ini dibutuhkan untuk kebutuhan konfirmasi dan login.
        </p>

        <div class="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
          <div class="sm:col-span-3">
            <label
              for="email"
              class="block text-sm font-medium leading-6 text-gray-900"
              >Email</label
            >
            <div class="mt-2">
              <input
                id="email"
                name="email"
                type="email"
                :value="modelValue.email"
                @input="updateField('email', $event.target.value)"
                autocomplete="email"
                class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 peer"
              />
            </div>
          </div>
          <div class="sm:col-span-3">
            <label
              for="no_hp"
              class="block text-sm font-medium leading-6 text-gray-900"
              >No. Hp</label
            >
            <div class="mt-2">
              <input
                id="no_hp"
                name="no_hp"
                type="text"
                :value="modelValue.no_hp"
                @input="updateField('no_hp', $event.target.value)"
                autocomplete="no_hp"
                class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              />
            </div>
          </div>
          <div class="sm:col-span-3">
            <label
              for="password"
              class="block text-sm font-medium leading-6 text-gray-900"
              >Password</label
            >
            <div class="mt-2">
              <input
                id="password"
                name="password"
                :value="modelValue.password"
                @input="updateField('password', $event.target.value)"
                type="password"
                class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              />
            </div>
            <p class="text-xs leading-5 text-gray-800 mt-1">
              *Minimal 6 karakter
            </p>
          </div>
          <div class="sm:col-span-3">
            <label
              for="password-conf"
              class="block text-sm font-medium leading-6 text-gray-900"
              >Konfirmasi Password</label
            >
            <div class="mt-2">
              <input
                id="password-conf"
                name="password-conf"
                v-model="passwordConf"
                type="password"
                @change="validateKonfirmasiPassword"
                :class="{ 'ring-red-500': errorKonfirmasiPassword }"
                class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              />
            </div>
            <p
              class="text-xs leading-5 text-red-600"
              v-if="errorKonfirmasiPassword"
            >
              Konfirmasi Password yang anda masukkan tidak sama
            </p>
          </div>
          <div class="sm:col-span-6 border-t pt-6 pb-6 border-b">
            <h2 class="text-base text-gray-800 font-medium font-sans">
              Sosial Media
            </h2>
            <p class="text-sm text-gray-500 font-medium">
              Kosongkan jika tidak ada
            </p>
            <div class="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
              <div class="sm:col-span-2">
                <label
                  for="facebook"
                  class="block text-sm font-medium leading-6 text-gray-900"
                  >Facebook</label
                >
                <div class="mt-2">
                  <div
                    class="flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-600 sm:max-w-md"
                  >
                    <span
                      class="flex select-none items-center px-2 text-indigo-700 sm:text-sm border-r bg-blue-800 rounded-l-md"
                      ><svg
                        class="w-5 h-5 text-blue-700 fill-white"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"
                          clip-rule="evenodd"
                        />
                      </svg>
                    </span>
                    <input
                      type="text"
                      name="facebook"
                      id="facebook"
                      autocomplete="facebook"
                      :value="modelValue.facebook"
                      @input="updateField('facebook', $event.target.value)"
                      class="block flex-1 border-0 bg-transparent py-1.5 pl-1 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm sm:leading-6"
                    />
                  </div>
                </div>
              </div>
              <div class="sm:col-span-2">
                <label
                  for="instagram"
                  class="block text-sm font-medium leading-6 text-gray-900"
                  >Instagram</label
                >
                <div class="mt-2">
                  <div
                    class="flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-600 sm:max-w-md"
                  >
                    <span
                      class="flex select-none items-center px-2 text-indigo-700 sm:text-sm border-r bg-gradient-to-br from-purple-500 to-orange-500 rounded-l-md"
                      ><svg
                        class="w-5 h-5 text-blue-700 fill-white"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
                          clip-rule="evenodd"
                        />
                      </svg>
                    </span>
                    <input
                      type="text"
                      name="instagram"
                      id="instagram"
                      autocomplete="instagram"
                      :value="modelValue.instagram"
                      @input="updateField('instagram', $event.target.value)"
                      class="block flex-1 border-0 bg-transparent py-1.5 pl-1 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm sm:leading-6"
                    />
                  </div>
                </div>
              </div>
              <div class="sm:col-span-2">
                <label
                  for="twitter"
                  class="block text-sm font-medium leading-6 text-gray-900"
                  >Twitter / X</label
                >
                <div class="mt-2">
                  <div
                    class="flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-600 sm:max-w-md"
                  >
                    <span
                      class="flex select-none items-center px-2 text-indigo-700 sm:text-sm border-r bg-blue-400 rounded-l-md"
                      ><svg class="w-5 h-5 fill-white" viewBox="0 0 24 24">
                        <path
                          d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84"
                        />
                      </svg>
                    </span>
                    <input
                      type="text"
                      name="twitter"
                      id="twitter"
                      autocomplete="twitter"
                      :value="modelValue.twitter"
                      @input="updateField('twitter', $event.target.value)"
                      class="block flex-1 border-0 bg-transparent py-1.5 pl-1 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm sm:leading-6"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="border-b border-gray-900/10 pb-12 px-6 pt-8 shadow-md rounded-xl bg-white"
      >
        <h2 class="text-base font-semibold leading-7 text-gray-900">
          Informasi pribadi
        </h2>
        <p class="mt-1 text-sm leading-6 text-gray-600">
          Gunakan data sesuai yang tertera di KTP.
        </p>

        <div class="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
          <div class="sm:col-span-full">
            <label
              for="nik"
              class="block text-sm font-medium leading-6 text-gray-900"
              >NIK (Nomor Induk Kependudukan)</label
            >
            <div class="mt-2">
              <input
                type="number"
                name="nik"
                id="nik"
                autocomplete="nik"
                :value="modelValue.nik"
                @input="updateField('nik', $event.target.value)"
                class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              />
            </div>
          </div>
          <div class="sm:col-span-full">
            <label
              for="nama_lengkap"
              class="block text-sm font-medium leading-6 text-gray-900"
              >Nama lengkap</label
            >
            <div class="mt-2">
              <input
                type="text"
                name="nama_lengkap"
                id="nama_lengkap"
                autocomplete="nama_lengkap"
                :value="modelValue.nama_lengkap"
                @input="updateField('nama_lengkap', $event.target.value)"
                class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              />
            </div>
          </div>

          <div class="sm:col-span-full">
            <label
              for="nama_arab"
              class="block text-sm font-medium leading-6 text-gray-900"
              >Nama Arab</label
            >
            <div class="mt-2">
              <input
                type="text"
                name="nama_arab"
                id="nama_arab"
                autocomplete="nama_arab"
                :value="modelValue.nama_arab"
                @input="updateField('nama_arab', $event.target.value)"
                class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              />
            </div>
            <p class="text-leading text-xs text-gray-400">
              Nama lengkap dalam huruf arab
            </p>
          </div>
          <div class="sm:col-span-3">
            <label
              for="tempat_lahir"
              class="block text-sm font-medium leading-6 text-gray-900"
              >Tempat lahir</label
            >
            <div class="mt-2">
              <input
                type="text"
                name="tempat_lahir"
                id="tempat_lahir"
                :value="modelValue.tempat_lahir"
                @input="updateField('tempat_lahir', $event.target.value)"
                autocomplete="tempat_lahir"
                class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              />
            </div>
          </div>
          <div class="sm:col-span-3 hidden sm:block"></div>
          <div class="sm:col-span-3">
            <label
              for="tanggal_lahir"
              class="block text-sm font-medium leading-6 text-gray-900"
              >Tanggal lahir</label
            >
            <div class="mt-2">
              <input
                type="date"
                name="tanggal_lahir"
                id="tanggal_lahir"
                :value="modelValue.tanggal_lahir"
                @input="updateField('tanggal_lahir', $event.target.value)"
                autocomplete="tanggal_lahir"
                class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              />
            </div>
          </div>

          <div class="sm:col-span-3 hidden sm:block"></div>
          <div class="sm:col-span-3">
            <label
              for="kelamin"
              class="block text-sm font-medium leading-6 text-gray-900"
              >Jenis Kelamin</label
            >
            <div class="mt-2">
              <select
                id="kelamin"
                name="kelamin"
                autocomplete="jenis-kelamin"
                :value="modelValue.jenis_kelamin"
                @change="updateField('jenis_kelamin', $event.target.value)"
                class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:max-w-xs sm:text-sm sm:leading-6"
              >
                <option value="L">Laki-laki</option>
                <option value="P">Perempuan</option>
              </select>
            </div>
          </div>
          <div class="sm:col-span-3 hidden sm:block"></div>
          <div class="sm:col-span-3">
            <label
              for="status_pernikahan"
              class="block text-sm font-medium leading-6 text-gray-900"
              >Status Pernikahan</label
            >
            <div class="mt-2">
              <select
                id="status_pernikahan"
                name="status_pernikahan"
                autocomplete="status_pernikahan"
                :value="modelValue.status_pernikahan"
                @change="updateField('status_pernikahan', $event.target.value)"
                class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:max-w-xs sm:text-sm sm:leading-6"
              >
                <option value="Belum menikah">Belum Menikah</option>
                <option value="Menikah">Sudah Menikah</option>
                <option value="Cerai">Cerai</option>
              </select>
            </div>
          </div>
          <div class="col-span-full">
            <label
              for="alamat"
              class="block text-sm font-medium leading-6 text-gray-900"
              >Alamat lengkap</label
            >
            <div class="mt-2">
              <textarea
                id="alamat"
                name="alamat"
                autocomplete="alamat"
                :value="modelValue.alamat"
                @input="updateField('alamat', $event.target.value)"
                rows="3"
                class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              ></textarea>
            </div>
          </div>

          <div class="sm:col-span-2 sm:col-start-1">
            <label
              for="provinsi"
              class="block text-sm font-medium leading-6 text-gray-900"
              >Provinsi</label
            >
            <div class="mt-2">
              <select
                :value="modelValue.provinsi"
                @change="onProvinsiChange($event.target.value)"
                class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              >
                <option disabled value="">Pilih Provinsi</option>
                <option
                  v-for="provinsi in provinces"
                  :key="provinsi.code"
                  :code="provinsi.code"
                  :value="provinsi.name"
                >
                  {{ provinsi.name }}
                </option>
              </select>
            </div>
          </div>

          <div class="sm:col-span-2">
            <label
              for="kab_kota"
              class="block text-sm font-medium leading-6 text-gray-900"
              >Kabupaten / Kota</label
            >
            <div class="mt-2">
              <select
                :value="modelValue.kota_kab"
                @change="onRegencyChange($event.target.value)"
                class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              >
                <option disabled value="">Pilih Kabupaten / Kota</option>
                <option
                  v-for="kab in regencies"
                  :key="kab.code"
                  :value="kab.name"
                >
                  {{ kab.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="sm:col-span-2">
            <label
              for="kecamatan"
              class="block text-sm font-medium leading-6 text-gray-900"
              >Kecamatan</label
            >
            <div class="mt-2">
              <select
                :value="modelValue.kecamatan"
                @change="updateField('kecamatan', $event.target.value)"
                class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              >
                <option disabled value="">Pilih Kecamatan</option>
                <option
                  v-for="kec in districts"
                  :key="kec.code"
                  :value="kec.name"
                >
                  {{ kec.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="sm:col-span-2">
            <label
              for="postal-code"
              class="block text-sm font-medium leading-6 text-gray-900"
              >Kode Pos</label
            >
            <div class="mt-2">
              <input
                type="text"
                name="postal-code"
                id="postal-code"
                autocomplete="postal-code"
                :value="modelValue.kodepos"
                @input="updateField('kodepos', $event.target.value)"
                class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              />
            </div>
          </div>
          <div class="col-span-full">
            <label
              for="cover-photo"
              class="block text-sm font-medium leading-6 text-gray-900"
              >Pas Foto</label
            >
            <div
              class="mt-2 flex justify-center rounded-lg border border-dashed border-gray-900/25 px-6 py-10"
            >
              <div class="text-center">
                <svg
                  v-if="!modelValue.pas_foto"
                  class="mx-auto h-12 w-12 text-gray-300"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path
                    fill-rule="evenodd"
                    d="M1.5 6a2.25 2.25 0 012.25-2.25h16.5A2.25 2.25 0 0122.5 6v12a2.25 2.25 0 01-2.25 2.25H3.75A2.25 2.25 0 011.5 18V6zM3 16.06V18c0 .414.336.75.75.75h16.5A.75.75 0 0021 18v-1.94l-2.69-2.689a1.5 1.5 0 00-2.12 0l-.88.879.97.97a.75.75 0 11-1.06 1.06l-5.16-5.159a1.5 1.5 0 00-2.12 0L3 16.061zm10.125-7.81a1.125 1.125 0 112.25 0 1.125 1.125 0 01-2.25 0z"
                    clip-rule="evenodd"
                  />
                </svg>
                <div v-else class="thumbnail">
                  <img
                    :src="thumbnailUrl"
                    alt="File thumbnail"
                    class="max-w-full max-h-96 mx-auto mb-4"
                  />
                  <span>{{ modelValue.pas_foto.name }}</span>
                </div>
                <div
                  class="mt-4 flex text-sm leading-6 text-gray-600 justify-center"
                >
                  <label
                    for="file-upload"
                    class="relative cursor-pointer rounded-md bg-white font-semibold text-indigo-600 focus-within:outline-none focus-within:ring-2 focus-within:ring-indigo-600 focus-within:ring-offset-2 hover:text-indigo-500"
                  >
                    <span>Upload a file</span>
                    <input
                      id="file-upload"
                      @change="onFileChange"
                      ref="modelValue.pas_foto"
                      name="file-upload"
                      type="file"
                      class="sr-only"
                    />
                  </label>
                </div>
                <p class="text-xs leading-5 text-gray-600">
                  PNG, JPG max size 2MB
                </p>
                <p class="text-xs leading-5 text-red-600">
                  *Pastikan wajah terlihat jelas, tidak tertutup ataupun
                  terpotong
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="bg-red-100 border-t-4 border-red-500 rounded-b text-red-900 px-4 py-3 shadow-md"
        role="alert"
        v-if="errorMessage"
      >
        <div class="flex">
          <div class="py-1">
            <svg
              class="fill-current h-6 w-6 text-red-500 mr-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path
                d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z"
              />
            </svg>
          </div>
          <div>
            <p class="font-bold">Masih ada yang error</p>
            <p class="text-sm">
              {{ errorMessage }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-6 flex items-center justify-end gap-x-6">
      <button
        type="submit"
        class="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 group-invalid:pointer-events-none group-invalid:opacity-30"
      >
        Selanjutnya
      </button>
    </div>
  </form>
  <ModalError @close-modal="closeModal" :message="errorMessageFile" />
</template>

<script setup>
import { defineProps, defineEmits, ref, onMounted } from "vue";
import ModalError from "./ModalError.vue";

const apiUrl = process.env.VUE_APP_API_URL;
// Menerima props yang dikirim dari parent
const props = defineProps({
  modelValue: Object, // Menerima seluruh objek form sebagai prop
});

const emit = defineEmits(["update:modelValue", "next"]);
const passwordConf = ref("");
const provinces = ref([]);
const regencies = ref([]);
const districts = ref([]);
const thumbnailUrl = ref(null);
const errorMessageFile = ref(null);
const errorMessage = ref(null);
const errorKonfirmasiPassword = ref(false);
// Fungsi untuk memperbarui field tertentu dalam objek form
const updateField = (field, value) => {
  emit("update:modelValue", { ...props.modelValue, [field]: value });
};

const validateKonfirmasiPassword = () => {
  if (passwordConf.value !== props.modelValue.password && passwordConf.value) {
    errorKonfirmasiPassword.value = "Konfirmasi password tidak sesuai.";
  } else {
    errorKonfirmasiPassword.value = null;
  }
};

const fetchRegencies = async (provinceCode) => {
  try {
    const response = await fetch(`${apiUrl}/getRegencies/${provinceCode}`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    regencies.value = data.data; // Menyimpan data kabupaten
  } catch (error) {
    console.error("Error fetching regencies:", error.message);
  }
};
const fetchDistricts = async (regencyCode) => {
  try {
    const response = await fetch(`${apiUrl}/getDistricts/${regencyCode}`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    districts.value = data.data; // Menyimpan data kabupaten
  } catch (error) {
    console.error("Error fetching regencies:", error.message);
  }
};

// Fungsi yang dipanggil saat provinsi berubah
const onProvinsiChange = (provinceName) => {
  const selectedProvince = provinces.value.find(
    (prov) => prov.name === provinceName
  );
  if (selectedProvince) {
    updateField("provinsi", selectedProvince.name); // Update modelValue untuk provinsi dengan nama
    districts.value = [];
    fetchRegencies(selectedProvince.code); // Menggunakan id provinsi untuk memfetch kabupaten
  }
};

const onRegencyChange = (regencyName) => {
  const selectedRegency = regencies.value.find(
    (prov) => prov.name === regencyName
  );
  if (selectedRegency) {
    updateField("kota_kab", selectedRegency.name);
    fetchDistricts(selectedRegency.code); // Menggunakan id provinsi untuk memfetch kabupaten
  }
};

const onFileChange = (event) => {
  const selectedFile = event.target.files[0];
  if (selectedFile) {
    validateFile(selectedFile);
  }
};
const validateFile = (file) => {
  const validTypes = ["image/jpeg", "image/png"];
  const maxSize = 2 * 1024 * 1024; // 5MB dalam bytes

  if (!validTypes.includes(file.type)) {
    errorMessageFile.value = "File harus berupa JPG atau PNG.";
    updateField("pas_foto", null);
    thumbnailUrl.value = null;
    return;
  }

  if (file.size > maxSize) {
    errorMessageFile.value = "Ukuran file tidak boleh lebih dari 2MB.";
    updateField("pas_foto", null);
    thumbnailUrl.value = null;
    return;
  }

  // Jika validasi berhasil, reset error dan buat thumbnail
  errorMessageFile.value = null;
  updateField("pas_foto", file);
  generateThumbnail(file);
};

const generateThumbnail = (file) => {
  if (file && file.type.startsWith("image/")) {
    const reader = new FileReader();
    reader.onload = (e) => {
      thumbnailUrl.value = e.target.result;
    };
    reader.readAsDataURL(file);
  } else {
    thumbnailUrl.value = null; // Jika bukan gambar, tidak menampilkan thumbnail
  }
};

const closeModal = () => {
  errorMessageFile.value = "";
};

const validateForm = () => {
  emit("next");
  // const requiredFields = [
  //   "email",
  //   "no_hp",
  //   "password",
  //   "nik",
  //   "nama_lengkap",
  //   "nama_arab",
  //   "jenis_kelamin",
  //   "status_pernikahan",
  //   "tempat_lahir",
  //   "tanggal_lahir",
  //   "alamat",
  //   "provinsi",
  //   "kota_kab",
  //   "kecamatan",
  //   "kodepos",
  //   "pas_foto",
  // ];
  // const hasError = requiredFields.some((field) => {
  //   if (!props.modelValue[field]) {
  //     let fieldText = document.querySelector(
  //       'label[for="' + field + '"]'
  //     ).textContent;
  //     errorMessage.value = `Field ${fieldText} tidak boleh kosong.`;
  //     return true;
  //   }
  //   return false;
  // });
  // if (!hasError) emit("next");
};
onMounted(async () => {
  try {
    const response = await fetch(`${apiUrl}/getProvinces`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    provinces.value = data.data; // Menyimpan data provinsi
  } catch (error) {
    console.error("Error fetching provinces:", error.message); // Tampilkan pesan error yang lebih jelas
  }
});
</script>

<style></style>
